import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import styles from '../../CommunityPage.module.scss';
import CompanyListItem from './CompanyListItem';

const CompanyListMode = ({ companies, onScroll, loading }) => (
  <Box className={styles.expertsList} onScroll={onScroll}>
    {companies && companies.map((company) => <CompanyListItem company={company} />)}
    {loading && !companies && (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
        <CircularProgress
          sx={{
            width: '40px !important',
            height: '40px !important',
          }}
        />
      </Box>
    )}
  </Box>
);

export default CompanyListMode;
